// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iterations-wrapper {
  width: 100%;
  overflow: visible;
  position: relative;
}

.actions-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.toolbar-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toolbar-label {
  margin: 0;
  font-size: 0.8rem;
  color: #555;
  font-weight: 600;
}

.chemical-search-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 200px;
  overflow: visible;
  z-index: 1001;
}

.chemical-search-input {
  width: 100%;
  min-height: 32px;
  padding: 4px 8px;
  font-size: 0.85rem;
}

.chemical-dropdown {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 9999;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 100%;
  pointer-events: auto;
}

.chemical-option {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 0.85rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.chemical-option:hover {
  background-color: #f0f0f0;
}
.chemical-option:active {
  background-color: #e0e0e0;
}

.no-results {
  padding: 12px;
  text-align: center;
  font-size: 0.85rem;
  color: #999;
  font-style: italic;
}

.action-error {
  color: #a94442;
  font-size: 0.8rem;
  margin-bottom: 8px;
}

.action-warning {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border: 1px solid #faebcc;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 0.8rem;
  margin-bottom: 8px;
}

.iterations-scroll {
  min-width: max-content;
  overflow: visible;
  position: relative;
}

.iterations-table {
  border-collapse: collapse;
  font-size: 0.85rem;
  width: 100%;
  overflow: visible;
  position: relative;
}
.iterations-table th,
.iterations-table td {
  border: 1px solid #e6e6e6;
  padding: 6px 10px;
  vertical-align: top;
  overflow: visible;
}
.iterations-table th {
  background-color: #0066b2;
  color: #fff;
  text-align: center;
  white-space: nowrap;
}

.caption-col {
  width: 720px;
  min-width: 720px;
  max-width: 720px;
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 1;
  overflow: visible !important;
}

.iterations-table.is-cutback .caption-col {
  width: 600px;
  min-width: 600px;
  max-width: 600px;
}

thead th.caption-col {
  background-color: #0066b2;
  padding: 6px 10px;
}

.blend-row .caption-col {
  z-index: 1002;
  overflow: visible !important;
}

.design-col {
  width: 140px;
  min-width: 140px;
  max-width: 140px;
  text-align: right;
  background: #fff;
}

.action-col {
  min-width: 110px;
  text-align: center;
  border-left: 2px solid #ccc;
  background: #fff;
}

thead .action-col {
  position: relative;
}

.iteration-actions-menu {
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  z-index: 2;
}
.iteration-actions-menu summary {
  list-style: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 102px;
}
.iteration-actions-menu summary::-webkit-details-marker {
  display: none;
}
.iteration-actions-menu.is-disabled {
  opacity: 0.7;
  pointer-events: none;
}

.iteration-actions-list {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 240px;
  background: #fff;
  border: 1px solid #cfd7e6;
  border-radius: 4px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
  z-index: 1100;
  display: flex;
  flex-direction: column;
  padding: 4px 0;
}

.iteration-action-item {
  border: none;
  background: transparent;
  text-align: left;
  width: 100%;
  padding: 7px 10px;
  color: #223;
  font-size: 0.85rem;
  cursor: pointer;
}
.iteration-action-item:hover:not(:disabled) {
  background-color: #d8e9ff;
}
.iteration-action-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.design-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.design-name-input {
  min-width: 120px;
  text-align: center;
  align-content: center;
  font-weight: 600;
  resize: none;
  overflow: hidden;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.4;
}

.component-name {
  font-size: 0.85rem;
}

.component-role-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 6px;
  font-size: 0.7rem;
  font-weight: 600;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
  vertical-align: middle;
}
.component-role-badge.base-fluid {
  background-color: #e3f2fd;
  color: #1565c0;
  border: 1px solid #90caf9;
}
.component-role-badge.weighing-agent {
  background-color: #fff3e0;
  color: #e65100;
  border: 1px solid #ffe0b2;
}

.caption-cell-split {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr) 80px 60px 120px 100px;
  gap: 4px;
  align-items: stretch;
}

.caption-cell-split.is-cutback {
  grid-template-columns: 100px minmax(0, 1fr) 70px 120px;
}

.caption-cell-split.is-cutback > .caption-part:last-child {
  overflow: hidden;
  padding-left: 2px;
  padding-right: 2px;
}

.caption-cell-split.is-cutback .barcode-actions {
  gap: 4px;
}

.caption-cell-split.is-cutback .barcode-link {
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
}

.caption-cell-split.is-cutback .material-details-btn {
  padding: 0 2px;
  font-size: 0.85rem;
}

.caption-cell-split.is-cutback .barcode-clear-btn {
  font-size: 1.2rem;
}

.caption-cell-split > .caption-part:first-child {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
}

.btn-remove-component {
  padding: 0 !important;
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  line-height: 20px !important;
}
.btn-remove-component .mat-icon {
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}

.btn-remove-iteration {
  padding: 0 !important;
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  line-height: 5% !important;
}
.btn-remove-iteration .mat-icon {
  width: 26px;
  height: 26px;
  font-size: 26px;
  line-height: 26px;
}

.caption-header-split {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr) 80px 60px 120px 100px;
  gap: 4px;
  align-items: center;
  height: 100%;
}

.caption-header-split.is-cutback {
  grid-template-columns: 100px minmax(0, 1fr) 70px 120px;
}

.caption-header-cell {
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  padding: 4px 2px;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 1.15;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}

.caption-header-cell:last-child {
  border-right: none;
}

.caption-part {
  display: flex;
  align-items: center;
  padding: 3px 5px;
  border-right: 1px solid #e6e6e6;
}

.caption-part:last-child {
  border-right: none;
}

.caption-part-small {
  padding: 3px 5px;
  width: 28px;
  min-width: 28px;
  max-width: 28px;
  border-right: 1px solid #e6e6e6;
}

.caption-part-small:last-child {
  border-right: none;
}

.caption-part-label {
  font-size: 0.94rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #6d6d6d;
  margin-bottom: 1px;
  letter-spacing: 0.02em;
}

.blend-material-controls {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
  overflow: visible;
  position: relative;
  z-index: 1001;
}

.blend-material-select {
  width: 200px;
}

.blend-row td {
  overflow: visible !important;
  position: relative;
  vertical-align: top;
  z-index: 1001;
}

.blend-row-label {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #1e5f9c;
  background-color: #dcecff;
  border-radius: 10px;
}

.child-row .caption-col {
  background-color: #fcfcfc;
}

.child-name {
  padding-left: 16px;
}

.blend-composite-row td {
  vertical-align: top;
}

.blend-proportional-row td {
  background-color: #f8fbf8;
  vertical-align: middle;
}

.blend-proportional-name {
  padding-left: 24px;
  font-size: 0.85rem;
  color: #444;
}

.sequence-editor {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.caption-cell-split .sequence-editor {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.sequence-label {
  font-size: 0.75rem;
  color: #666;
  margin: 0;
}

.sequence-input {
  width: 42px;
  padding: 2px 4px;
  font-size: 0.75rem;
}

.component-barcode,
.component-sg {
  font-size: 0.75rem;
  color: #666;
}

.barcode-link {
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
}
.barcode-link:hover {
  text-decoration-thickness: 2px;
}
.barcode-link:focus-visible {
  outline: 1px dashed #6c757d;
  outline-offset: 2px;
}

.barcode-actions {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  white-space: nowrap;
}

.barcode-clear-btn {
  border: none;
  background: transparent;
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  color: #8a8a8a;
}
.barcode-clear-btn:hover {
  color: #b52b27;
}
.barcode-clear-btn:disabled {
  cursor: default;
  opacity: 0.55;
}

.material-details-btn {
  border: none;
  background: transparent;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  color: #5a7fbf;
  padding: 0 2px;
}
.material-details-btn:hover {
  color: #2c4a86;
}

.component-barcode.empty {
  color: #9b9b9b;
}

.weight-cell {
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.weight-input {
  width: 70px;
  padding: 2px 4px;
  font-size: 0.85rem;
  text-align: right;
}

.sg-input {
  width: 60px;
  padding: 2px 4px;
  font-size: 0.85rem;
  text-align: right;
}

.unit {
  color: #888;
  font-size: 0.75rem;
  margin-left: 2px;
}

.summary-row td {
  background-color: #f9f9f9;
  font-weight: 600;
}

.actions-row td {
  background-color: #fff;
  padding: 2px 6px;
}

.empty-state {
  padding: 24px 0;
  color: #666;
  font-style: italic;
}
.empty-state p {
  margin-bottom: 12px;
}

.tests-actions-row td {
  background-color: #eef2ff;
  padding: 2px 6px;
}

.row-section-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #444;
}

.comments-link {
  cursor: pointer;
  color: #0066cc;
  text-decoration: underline;
  font-size: 1rem;
  padding: 2px 0;
}
.comments-link:hover {
  color: #0052a3;
  text-decoration: underline;
}
.comments-link.disabled {
  color: #999;
  cursor: not-allowed;
  text-decoration: none;
  opacity: 0.6;
}

.comments-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.delete-iteration-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.delete-iteration-cell button[mat-icon-button] {
  width: 56px;
  height: 56px;
  line-height: 56px;
}
.delete-iteration-cell mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
}

.tests-toggle-btn {
  font-size: 1rem;
  color: #fff;
  padding: 2px 6px;
  white-space: nowrap;
}
.tests-toggle-btn.tests-toggle-active {
  color: #fff;
  background-color: #3c4a8a;
  border-radius: 4px;
  text-decoration: none;
}

.iteration-tests-panel {
  margin-top: 16px;
  border: 1px solid #c5cae9;
  border-radius: 6px;
  background: #fff;
  padding: 0 0 12px 0;
  overflow: hidden;
}

.iteration-tests-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #0066b2;
  color: #fff;
  padding: 8px 14px;
  font-size: 0.9rem;
}

.tests-panel-close {
  border-color: rgba(255, 255, 255, 0.6);
  color: #fff;
  padding: 1px 7px;
  font-size: 0.85rem;
}
.tests-panel-close:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: #fff;
  color: #fff;
}

.density-display {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e5f9c;
  text-align: center;
  white-space: nowrap;
  padding: 2px 0;
}

.volume-row td {
  background: #f5f8fc;
  border-top: 1px solid #d0d7e3;
}

.volume-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 4px;
}

.volume-input-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.volume-input-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.volume-unit-label {
  min-width: 28px;
  text-align: right;
  font-size: 0.72rem;
  font-weight: 700;
  color: #666;
  text-transform: uppercase;
}

.volume-input-field {
  width: 86px;
  text-align: right;
  font-size: 0.85rem;
}

.volume-display-stack {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-end;
}

.volume-display {
  font-size: 0.85rem;
  text-align: right;
  color: #555;
}
.volume-display.secondary {
  font-size: 0.75rem;
  color: #777;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/formulation-iterations/formulation-iterations.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADF;;AAIA;EACE,SAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AADF;;AAIA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,yCAAA;EACA,eAAA;EACA,oBAAA;AADF;;AAIA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AADF;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,yBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAHF;;AAMA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,sBAAA;EACA,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAHF;AAKE;;EAEE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;AAME;EACE,yBC3HU;ED4HV,WAAA;EACA,kBAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,OAAA;EACA,gBAAA;EACA,UAAA;EACA,4BAAA;AALF;;AAQA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AALF;;AAQA;EACE,yBCpJY;EDqJZ,iBAAA;AALF;;AAQA;EACE,aAAA;EACA,4BAAA;AALF;;AAQA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;AALF;AAOE;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AALJ;AAQE;EACE,aAAA;AANJ;AASE;EACE,YAAA;EACA,oBAAA;AAPJ;;AAWA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AARF;;AAWA;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AARF;AAUE;EACE,yBAAA;AARJ;AAWE;EACE,YAAA;EACA,mBAAA;AATJ;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAVF;;AAaA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,kBAAA;AAVF;;AAcA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AAXF;AAaE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAXJ;AAcE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,iEAAA;EACA,QAAA;EACA,oBAAA;AAbF;;AAgBA;EACE,sDAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,QAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,iBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAbF;;AAgBA;EACE,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;AAbF;AAeE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAbJ;;AAiBA;EACE,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,0BAAA;AAdF;AAgBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,iEAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AAfF;;AAkBA;EACE,sDAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gDAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,+BAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,+BAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,YAAA;AAfF;;AAkBA;EACE,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AAfF;;AAkBA;EACE,yBAAA;AAfF;;AAkBA;EACE,kBAAA;AAfF;;AAkBA;EACE,mBAAA;AAfF;;AAkBA;EACE,yBAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAfF;;AAkBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAfF;;AAkBA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAfF;;AAkBA;;EAEE,kBAAA;EACA,WAAA;AAfF;;AAkBA;EACE,qBAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;AAfF;AAiBE;EACE,8BAAA;AAfJ;AAkBE;EACE,2BAAA;EACA,mBAAA;AAhBJ;;AAqBA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AAlBF;AAoBE;EACE,cAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,aAAA;AAnBJ;;AAuBA;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AApBF;AAsBE;EACE,cAAA;AApBJ;;AAwBA;EACE,cAAA;AArBF;;AAwBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AArBF;;AAwBA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,yBAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,sBAAA;EACA,gBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AArBF;AAuBE;EACE,mBAAA;AArBJ;;AAyBA;EACE,yBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;AAtBF;;AAyBA;EACE,eAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;AAtBF;AAwBE;EACE,cAAA;EACA,0BAAA;AAtBJ;AAyBE;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;AAvBJ;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAxBF;AA0BE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAxBJ;AA2BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzBJ;;AA6BA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AA1BF;AA4BE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AA1BJ;;AA8BA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBChsBY;EDisBZ,WAAA;EACA,iBAAA;EACA,iBAAA;AA3BF;;AA8BA;EACE,sCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA3BF;AA6BE;EACE,2CAAA;EACA,kBAAA;EACA,WAAA;AA3BJ;;AA+BA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,6BAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;AA5BF;AA8BE;EACE,kBAAA;EACA,WAAA;AA5BJ","sourcesContent":["@use '../../../../../styles/colors' as c;\n\n.iterations-wrapper {\n  width: 100%;\n  overflow: visible;\n  position: relative;\n}\n\n.actions-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.toolbar-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.toolbar-label {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #555;\n  font-weight: 600;\n}\n\n.chemical-search-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 200px;\n  overflow: visible;\n  z-index: 1001;\n}\n\n.chemical-search-input {\n  width: 100%;\n  min-height: 32px;\n  padding: 4px 8px;\n  font-size: 0.85rem;\n}\n\n.chemical-dropdown {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 9999;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  min-width: 100%;\n  pointer-events: auto;\n}\n\n.chemical-option {\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  &:hover {\n    background-color: #f0f0f0;\n  }\n\n  &:active {\n    background-color: #e0e0e0;\n  }\n}\n\n.no-results {\n  padding: 12px;\n  text-align: center;\n  font-size: 0.85rem;\n  color: #999;\n  font-style: italic;\n}\n\n.action-error {\n  color: #a94442;\n  font-size: 0.8rem;\n  margin-bottom: 8px;\n}\n\n.action-warning {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border: 1px solid #faebcc;\n  border-radius: 4px;\n  padding: 6px 8px;\n  font-size: 0.8rem;\n  margin-bottom: 8px;\n}\n\n.iterations-scroll {\n  min-width: max-content;\n  overflow: visible;\n  position: relative;\n}\n\n.iterations-table {\n  border-collapse: collapse;\n  font-size: 0.85rem;\n  width: 100%;\n  overflow: visible;\n  position: relative;\n\n  th,\n  td {\n    border: 1px solid #e6e6e6;\n    padding: 6px 10px;\n    vertical-align: top;\n    overflow: visible;\n  }\n\n  th {\n    background-color: c.$medium-blue;\n    color: #fff;\n    text-align: center;\n    white-space: nowrap;\n  }\n}\n\n.caption-col {\n  width: 720px;\n  min-width: 720px;\n  max-width: 720px;\n  position: sticky;\n  left: 0;\n  background: #fff;\n  z-index: 1;\n  overflow: visible !important;\n}\n\n.iterations-table.is-cutback .caption-col {\n  width: 600px;\n  min-width: 600px;\n  max-width: 600px;\n}\n\nthead th.caption-col {\n  background-color: c.$medium-blue;\n  padding: 6px 10px;\n}\n\n.blend-row .caption-col {\n  z-index: 1002;\n  overflow: visible !important;\n}\n\n.design-col {\n  width: 140px;\n  min-width: 140px;\n  max-width: 140px;\n  text-align: right;\n  background: #fff;\n}\n\n.action-col {\n  min-width: 110px;\n  text-align: center;\n  border-left: 2px solid #ccc;\n  background: #fff;\n}\n\nthead .action-col {\n  position: relative;\n}\n\n.iteration-actions-menu {\n  position: absolute;\n  left: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-block;\n  z-index: 2;\n\n  summary {\n    list-style: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 102px;\n  }\n\n  summary::-webkit-details-marker {\n    display: none;\n  }\n\n  &.is-disabled {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n}\n\n.iteration-actions-list {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  min-width: 240px;\n  background: #fff;\n  border: 1px solid #cfd7e6;\n  border-radius: 4px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);\n  z-index: 1100;\n  display: flex;\n  flex-direction: column;\n  padding: 4px 0;\n}\n\n.iteration-action-item {\n  border: none;\n  background: transparent;\n  text-align: left;\n  width: 100%;\n  padding: 7px 10px;\n  color: #223;\n  font-size: 0.85rem;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background-color: #d8e9ff;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.design-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.design-name-input {\n  min-width: 120px;\n  text-align: center;\n  align-content: center;\n  font-weight: 600;\n  resize: none;\n  overflow: hidden;\n  white-space: pre-wrap;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n.component-name {\n  font-size: 0.85rem;\n}\n\n// ── Component role badges ─────────────────────────────────────────────────────\n.component-role-badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 2px 6px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  border-radius: 3px;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  vertical-align: middle;\n\n  &.base-fluid {\n    background-color: #e3f2fd;\n    color: #1565c0;\n    border: 1px solid #90caf9;\n  }\n\n  &.weighing-agent {\n    background-color: #fff3e0;\n    color: #e65100;\n    border: 1px solid #ffe0b2;\n  }\n}\n\n.caption-cell-split {\n  display: grid;\n  grid-template-columns: 100px minmax(0, 1fr) 80px 60px 120px 100px;\n  gap: 4px;\n  align-items: stretch;\n}\n\n.caption-cell-split.is-cutback {\n  grid-template-columns: 100px minmax(0, 1fr) 70px 120px;\n}\n\n.caption-cell-split.is-cutback > .caption-part:last-child {\n  overflow: hidden;\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.caption-cell-split.is-cutback .barcode-actions {\n  gap: 4px;\n}\n\n.caption-cell-split.is-cutback .barcode-link {\n  max-width: 110px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 0.75rem;\n}\n\n.caption-cell-split.is-cutback .material-details-btn {\n  padding: 0 2px;\n  font-size: 0.85rem;\n}\n\n.caption-cell-split.is-cutback .barcode-clear-btn {\n  font-size: 1.2rem;\n}\n\n.caption-cell-split > .caption-part:first-child {\n  width: 100px;\n  min-width: 100px;\n  max-width: 100px;\n}\n\n.btn-remove-component {\n  padding: 0 !important;\n  width: 20px !important;\n  height: 20px !important;\n  min-width: 20px !important;\n  line-height: 20px !important;\n\n  .mat-icon {\n    width: 16px;\n    height: 16px;\n    font-size: 16px;\n    line-height: 16px;\n  }\n}\n\n.btn-remove-iteration {\n  padding: 0 !important;\n  width: 30px !important;\n  height: 30px !important;\n  min-width: 30px !important;\n  line-height: 5% !important;\n\n  .mat-icon {\n    width: 26px;\n    height: 26px;\n    font-size: 26px;\n    line-height: 26px;\n  }\n}\n\n.caption-header-split {\n  display: grid;\n  grid-template-columns: 100px minmax(0, 1fr) 80px 60px 120px 100px;\n  gap: 4px;\n  align-items: center;\n  height: 100%;\n}\n\n.caption-header-split.is-cutback {\n  grid-template-columns: 100px minmax(0, 1fr) 70px 120px;\n}\n\n.caption-header-cell {\n  font-weight: 700;\n  font-size: 1rem;\n  text-align: center;\n  padding: 4px 2px;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  line-height: 1.15;\n  border-right: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.caption-header-cell:last-child {\n  border-right: none;\n}\n\n.caption-part {\n  display: flex;\n  align-items: center;\n  padding: 3px 5px;\n  border-right: 1px solid #e6e6e6;\n}\n\n.caption-part:last-child {\n  border-right: none;\n}\n\n.caption-part-small {\n  padding: 3px 5px;\n  width: 28px;\n  min-width: 28px;\n  max-width: 28px;\n  border-right: 1px solid #e6e6e6;\n}\n\n.caption-part-small:last-child {\n  border-right: none;\n}\n\n.caption-part-label {\n  font-size: 0.94rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #6d6d6d;\n  margin-bottom: 1px;\n  letter-spacing: 0.02em;\n}\n\n.blend-material-controls {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n  overflow: visible;\n  position: relative;\n  z-index: 1001;\n}\n\n.blend-material-select {\n  width: 200px;\n}\n\n.blend-row td {\n  overflow: visible !important;\n  position: relative;\n  vertical-align: top;\n  z-index: 1001;\n}\n\n.blend-row-label {\n  display: inline-block;\n  margin-top: 6px;\n  padding: 2px 8px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #1e5f9c;\n  background-color: #dcecff;\n  border-radius: 10px;\n}\n\n.child-row .caption-col {\n  background-color: #fcfcfc;\n}\n\n.child-name {\n  padding-left: 16px;\n}\n\n.blend-composite-row td {\n  vertical-align: top;\n}\n\n.blend-proportional-row td {\n  background-color: #f8fbf8;\n  vertical-align: middle;\n}\n\n.blend-proportional-name {\n  padding-left: 24px;\n  font-size: 0.85rem;\n  color: #444;\n}\n\n.sequence-editor {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.caption-cell-split .sequence-editor {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.sequence-label {\n  font-size: 0.75rem;\n  color: #666;\n  margin: 0;\n}\n\n.sequence-input {\n  width: 42px;\n  padding: 2px 4px;\n  font-size: 0.75rem;\n}\n\n.component-barcode,\n.component-sg {\n  font-size: 0.75rem;\n  color: #666;\n}\n\n.barcode-link {\n  display: inline-block;\n  text-decoration: underline;\n  cursor: pointer;\n  white-space: nowrap;\n\n  &:hover {\n    text-decoration-thickness: 2px;\n  }\n\n  &:focus-visible {\n    outline: 1px dashed #6c757d;\n    outline-offset: 2px;\n  }\n  \n}\n\n.barcode-actions {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.barcode-clear-btn {\n  border: none;\n  background: transparent;\n  font-size: 1.3rem;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  color: #8a8a8a;\n\n  &:hover {\n    color: #b52b27;\n  }\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.55;\n  }\n}\n\n.material-details-btn {\n  border: none;\n  background: transparent;\n  font-size: 0.9rem;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  color: #5a7fbf;\n  padding: 0 2px;\n\n  &:hover {\n    color: #2c4a86;\n  }\n}\n\n.component-barcode.empty {\n  color: #9b9b9b;\n}\n\n.weight-cell {\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n.weight-input {\n  width: 70px;\n  padding: 2px 4px;\n  font-size: 0.85rem;\n  text-align: right;\n}\n\n.sg-input {\n  width: 60px;\n  padding: 2px 4px;\n  font-size: 0.85rem;\n  text-align: right;\n}\n\n.unit {\n  color: #888;\n  font-size: 0.75rem;\n  margin-left: 2px;\n}\n\n.summary-row td {\n  background-color: #f9f9f9;\n  font-weight: 600;\n}\n\n.actions-row td {\n  background-color: #fff;\n  padding: 2px 6px;\n}\n\n.empty-state {\n  padding: 24px 0;\n  color: #666;\n  font-style: italic;\n\n  p {\n    margin-bottom: 12px;\n  }\n}\n\n.tests-actions-row td {\n  background-color: #eef2ff;\n  padding: 2px 6px;\n}\n\n.row-section-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #444;\n}\n\n.comments-link {\n  cursor: pointer;\n  color: #0066cc;\n  text-decoration: underline;\n  font-size: 1rem;\n  padding: 2px 0;\n\n  &:hover {\n    color: #0052a3;\n    text-decoration: underline;\n  }\n\n  &.disabled {\n    color: #999;\n    cursor: not-allowed;\n    text-decoration: none;\n    opacity: 0.6;\n  }\n}\n\n.comments-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.delete-iteration-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n\n  button[mat-icon-button] {\n    width: 56px;\n    height: 56px;\n    line-height: 56px;\n  }\n\n  mat-icon {\n    font-size: 32px;\n    width: 32px;\n    height: 32px;\n  }\n}\n\n.tests-toggle-btn {\n  font-size: 1rem;\n  color: #fff;\n  padding: 2px 6px;\n  white-space: nowrap;\n\n  &.tests-toggle-active {\n    color: #fff;\n    background-color: #3c4a8a;\n    border-radius: 4px;\n    text-decoration: none;\n  }\n}\n\n.iteration-tests-panel {\n  margin-top: 16px;\n  border: 1px solid #c5cae9;\n  border-radius: 6px;\n  background: #fff;\n  padding: 0 0 12px 0;\n  overflow: hidden;\n}\n\n.iteration-tests-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: c.$medium-blue;\n  color: #fff;\n  padding: 8px 14px;\n  font-size: 0.9rem;\n}\n\n.tests-panel-close {\n  border-color: rgba(255, 255, 255, 0.6);\n  color: #fff;\n  padding: 1px 7px;\n  font-size: 0.85rem;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.15);\n    border-color: #fff;\n    color: #fff;\n  }\n}\n\n.density-display {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #1e5f9c;\n  text-align: center;\n  white-space: nowrap;\n  padding: 2px 0;\n}\n\n.volume-row td {\n  background: #f5f8fc;\n  border-top: 1px solid #d0d7e3;\n}\n\n.volume-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 4px;\n}\n\n.volume-input-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n}\n\n.volume-input-row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n.volume-unit-label {\n  min-width: 28px;\n  text-align: right;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #666;\n  text-transform: uppercase;\n}\n\n.volume-input-field {\n  width: 86px;\n  text-align: right;\n  font-size: 0.85rem;\n}\n\n.volume-display-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  align-items: flex-end;\n}\n\n.volume-display {\n  font-size: 0.85rem;\n  text-align: right;\n  color: #555;\n\n  &.secondary {\n    font-size: 0.75rem;\n    color: #777;\n  }\n}\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
